/* eslint-disable no-unused-vars */
import React, { useContext, useState, useRef, useMemo } from 'react'
import { Button, message, Select, Input, Popconfirm } from 'antd'
import {
  getApiTargetInfo,
  getEnvConfig,
  ExportComponent,
  UnitSelection,
} from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import MisoVerificationDialog from './MisoVerificationDialog'
import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'
import {
  rowHeaderRender,
  exportDataComponent,
  hasAccesPermits,
  dataSavedMessage,
} from 'core/utils'
import {
  UnitSelectionContext,
  SpinContext,
  ErrorContext,
  JcTmpErrorContext,
} from 'context'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getUnits,
  getCauseCodeMap,
  isUnitLoading,
  getAmlificationCode,
  getFailCode,
  getPermitActions,
  isAdminType,
} from 'core/selectors'
import { Label } from '../core/screen-util'

import moment from 'moment'
import * as ScreenPermissions from 'core/EventActions'
import {
  MisoVerificationTestHeaders,
  HeaderRowHeightVerification,
} from './Utils'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import {
  deleteMisoVerificationTestata,
  getMisoVerificationTest,
} from 'api/pgads'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'

const NetCapVerification = props => {
  const {
    unitNameMap,
    utilityNameMap,
    apiTargetInfo,
    yearSelection = [],
  } = props
  const curYear = parseInt(moment().format('YYYY'))

  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { setError } = useContext(ErrorContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const [year, setYear] = useState(curYear)
  // const [season, setSeason] = useState('S')

  const [data, setData] = useState([])

  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [selected, setSelected] = useState({})
  const [mode, setMode] = useState('I')

  const onCriteriaChnage = _ => setData([])

  const onRetrieve = _ => {
    if (selectedUnits.length <= 0) {
      message.warn('Please,select Unit(s)')
      setVisibleUnitSelection(true)
      return
    }
    const cr = {
      unitId: selectedUnits.map(u => u.unitId),
      year,
    }
    setSpinning(true)
    getMisoVerificationTest(apiTargetInfo)(cr).fork(setError, data => {
      setSpinning(false)
      setData(data)
    })
  }

  const GridRef = useRef()

  const headerWithFormatter = useMemo(
    _ =>
      MisoVerificationTestHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : { ...h, width: h.width ? h.width : 150 }
      ),
    [unitNameMap, utilityNameMap]
  )
  const title = 'Net Cap Verification'
  const [visible, setVisible] = useState(false)
  const netCapacityVerificationWrite = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: props.envConfig.authGodMode,
        actionPermits: props.actionPermits,
        eventActions: [
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_WRITE,
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_IMPORT,
        ],
        matchAny: true,
      }),
    [props.actionPermits, props.envConfig.authGodMode]
  )

  const deleteData = _ => {
    if (Object.keys(selected).length <= 0) {
      message.info('Please, Select Row')
      return
    }

    // setSpinning(true)
    deleteMisoVerificationTestata(apiTargetInfo)(selected).fork(
      setError,
      error => {
        setSpinning(false)
        setTmpError(error)
        if (!isErrorContains(error)) {
          dataSavedMessage()
          onRetrieve()
        }
      }
    )
  }
  const onInsert = _ => {
    setMode('I')
    setVisible(true)
    setSelected({
      year: moment().format('YYYY'),
      testIdx: -99,
      period: 'S',
    })
  }

  /*
    for (int i = 0; i < 16; i++) {
            stringYear = (new Integer(iYear + 1)).toString();
            yearComboBox.addItem(stringYear);
            iYear--;
            if (iYear < 2022) break;
        }
  */
  const misoYear = R.range(0, 16)
    .map(i => curYear + 1 - i)
    .filter(year => year > 2022)

  const yearSelect = yearSelection.length <= 0 ? misoYear : yearSelection

  return (
    <React.Fragment>
      <UnitSelection setData={onCriteriaChnage} />
      <CriteriaRow>
        <Title>{title}</Title>
        <Label style={{ marginLeft: 50, marginRight: '5px' }}>Year : </Label>
        <Select
          value={year}
          onChange={year => {
            setYear(year)
            onCriteriaChnage()
          }}
        >
          {yearSelect.map(y => (
            <Select.Option key={y} value={y}>
              {y}
            </Select.Option>
          ))}
        </Select>
        {/* <Label>Season : </Label>
        <Select value={season} onChange={setSeason}>
          <Select.Option key="S" value="S">
            Summer
          </Select.Option>
          <Select.Option key="W" value="W">
            Winter
          </Select.Option>
        </Select> */}

        <Button
          loading={spinning}
          onClick={onRetrieve}
          style={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>
        {netCapacityVerificationWrite && (
          <Button
            loading={spinning}
            onClick={onInsert}
            icon="plus-circle"
            style={{
              backgroundColor: '#e6f7ff',
              marginLeft: '10px',
            }}
          >
            Insert
          </Button>
        )}
        {netCapacityVerificationWrite && (
          <Button
            loading={spinning}
            onClick={_ => {
              if (Object.keys(selected || {}).length <= 0) {
                message.info('Please, Select Row')
                return
              }
              setMode('U')
              setVisible(true)
            }}
            style={{ marginLeft: '10px' }}
            type="primary"
            icon="edit"
            disabled={Object.keys(selected || {}).length <= 0}
          >
            Update
          </Button>
        )}

        {netCapacityVerificationWrite && (
          <Popconfirm
            title="Are you sure?"
            okText="Yes"
            cancelText="No"
            onConfirm={deleteData}
            placement="topRight"
            // disabled
          >
            <Button
              loading={spinning}
              icon="delete"
              style={{
                marginLeft: '10px',
                // color: '#FFFFFF',
                // backgroundColor: '#FF0000',
              }}
              type="danger"
              disabled={Object.keys(selected || {}).length <= 0}
            >
              Remove
            </Button>
          </Popconfirm>
        )}

        <div style={{ flex: '1 1 0px' }} />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        {/* <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          data={data}
          headers={(MisoVerificationTestHeaders || []).map(d => ({
            ...d,
            rowHeaderBackgroundColor: '#eee',
          }))}
          fileName={title}
          btnStyle={{ marginRight: '10px' }}
          disabled={data.length <= 0}
        /> */}
      </CriteriaRow>
      <FullHeightSizer heightOffset={250}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Grid
              ref={GridRef}
              // editMode="cell"
              data={data || []}
              headers={headerWithFormatter}
              altBy={o => o.unitId}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: true,
                rowHeaderRender,
                height: height - 40,
                width: width - 50,
                headerRowHeight: HeaderRowHeightVerification,
              })}
              fuzzyFilter={fuzzyFilter}
              onSelectionChange={({ selectedRows }) => {
                setSelected(selectedRows[0])
              }}
              initialSortOptions={MisoVerificationTestHeaders}
              sortOptions={MisoVerificationTestHeaders}
              sortEnabled
              isEditable={false}
              selectionType="row"
              selectionMode="single"
            />
          </Content>
        )}
      </FullHeightSizer>
      {visible && (
        <MisoVerificationDialog
          mode={mode}
          insertdata={{ ...selected, year }}
          unitNameMap={props.unitNameMap}
          utilityNameMap={utilityNameMap}
          visible={visible}
          setVisible={_ => {
            setVisible(false)
            setSelected({})
          }}
          apiTargetInfo={props.apiTargetInfo}
          setError={setError}
          setTmpError={setTmpError}
          netCapacityVerificationWrite={netCapacityVerificationWrite}
          units={props.units}
          onRetrieve={onRetrieve}
          yearSelect={yearSelect}
        />
      )}
    </React.Fragment>
  )
}

// const getXeforlData = (selected = {}, exfordDataList = []) => {
//   const found = exfordDataList.find(
//     x =>
//       x.unitId === selected.unitId &&
//       x.year === selected.year &&
//       x.period === selected.period &&
//       x.testIdx === selected.testIdx
//     // &&      x.standard === selected.standard
//   )

//   return found
// }

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  units: getUnits(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  isAdminType: isAdminType(state),
})

export default connect(mapStateToProps)(NetCapVerification)
